import { ArrowUp } from 'lucide-react'
import React from 'react'

export default function ScrollToTopBtn() {
    return (
        <div className='scroll-btn'>
            <button>
                <ArrowUp 
                    size={20}
                    stroke='#99999'
                />
            </button>
        </div>
    )
}
